export const FETCH_BALANCE_BY_WALLET = "FETCH_BALANCE_BY_WALLET";
export const FETCH_BALANCE_BY_WALLET_SUCCESS =
  "FETCH_BALANCE_BY_WALLET_SUCCESS";
export const FETCH_BALANCE_BY_WALLET_FAILURE =
  "FETCH_BALANCE_BY_WALLET_FAILURE";
export const RESET_BALANCE_BY_WALLET = "RESET_BALANCE_BY_WALLET";


export const FETCH_BALANCE_BY_GIFT_CARD = "FETCH_BALANCE_BY_GIFT_CARD";
export const FETCH_BALANCE_BY_GIFT_CARD_SUCCESS =
  "FETCH_BALANCE_BY_GIFT_CARD_SUCCESS";
export const FETCH_BALANCE_BY_GIFT_CARD_FAILURE =
  "FETCH_BALANCE_BY_GIFT_CARD_FAILURE";
export const RESET_BALANCE_BY_GIFT_CARD = "RESET_BALANCE_BY_GIFT_CARD";
